module.exports = "/legacy/72ca15d0d52335be5acd2e92be8105d2.svg";